/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Box, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus, OTP_LEN } from "../../../../contants";
import User from "../../../../services/api/user";
import OTPInput from "../../../../components/common/new/OTPInput/OTPInput";
import { createArrayByLen } from "../../../../utils/helper";
import otpSendingImage from "../../../../assets/images/send_otp.jpg";
import otpReceivedImage from "../../../../assets/images/verify_otp.jpg";

function ImpersonationModal({ selectedMember, onClose }) {
  const toast = useContext(ToastAlertContext);
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [otpImage, setOtpImage] = useState(otpSendingImage);
  const navigate = useNavigate();

  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpSent(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  const handleSendOtp = async () => {
    try {
      await User.InitiateImpersonate({}, selectedMember?.memberId);
      setOtpSent(true);
      setTimer(60);
      setOtpImage(otpReceivedImage);

      toast.show("OTP Sent successfully", AlertStatus.SUCCESS);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Failed to send OTP. Please try again.",
        AlertStatus.ERROR
      );
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const { elements } = event.target;
      const otpInString = createArrayByLen(OTP_LEN)
        .reduce((acc, _, index) => {
          return acc + (elements[`otp-${index + 1}`]?.value ?? "");
        }, "")
        ?.replace(/ /gi, "");

      if (otpInString.length < OTP_LEN) {
        toast.show("Please enter OTP", AlertStatus.ERROR);
        return;
      }
      const response = await User.ImpersonateOtherUser(
        { otp: Number(otpInString) },
        selectedMember?.memberId
      );
      const authToken = response.headers["x-auth-token"];
      const loginId = response.headers["login-id"];
      toast.show("Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("loginId", loginId);
        // window.open(process.env.REACT_APP_API_BASE_URL);
        navigate("/");
        window.location.reload(true);
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  return (
    <Box style={{ display: "flex" }}>
      <Box>
        <img
          src={otpImage}
          alt="OTP Image"
          // style={{ marginRight: "16px", width: "50px" }}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
      <form onSubmit={onSubmit}>
        <Box style={{ display: "flex" }}>
          <Typography variant="title2" color="#8c8c8c">
            Impersonation
          </Typography>

          <div
            style={{
              position: "relative",
              float: "right",
              top: "-8px",
              marginLeft: "auto",
            }}
          >
            <IconButton>
              <CloseIcon onClick={onClose} />
            </IconButton>
          </div>
        </Box>
        <Box mt={2}>
          {!otpSent && (
            <Typography
              style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleSendOtp}
              label="Send OTP"
              variant="outlined"
            >
              Send OTP
            </Typography>
          )}
          {otpSent && timer > 0 && (
            <Typography variant="small" color="#8c8c8c">
              Resend OTP in <span style={{ color: "#007bff" }}>{timer}</span>{" "}
              seconds
            </Typography>
          )}
        </Box>
        <Box>
          {otpSent ? (
            <Typography variant="small" fontWeight={500}>
              Enter the OTP we just sent to your registered email.
            </Typography>
          ) : (
            <Typography variant="small" fontWeight={500}>
              Click Send OTP to receive the OTP.
            </Typography>
          )}
        </Box>
        <Box mt={4}>
          <div
            style={{
              width: "250px",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "1rem",
            }}
          >
            {createArrayByLen(OTP_LEN).map((_, index) => (
              <OTPInput
                id={index + 1}
                style={{
                  height: 40,
                  background: "#F2F2F2",
                  fontSize: 16,
                  color: "#00000",
                }}
              />
            ))}
          </div>
        </Box>
        <Box style={{ display: "flex", gap: 16, justifyContent: "center" }}>
          <Button
            style={CommonStyles.buttonStyle}
            variant="contained"
            type="submit"
            label="Login"
            disabled={!otpSent}
          />
        </Box>
      </form>
    </Box>
  );
}

export default ImpersonationModal;
